import { Typography } from '@mui/material';
import styles from './Header.module.css';

function HeaderLogo() {
  return (
    <>
      <img src='/lifetouch_logo.png' alt='' className={styles.logo} />
      <Typography
        variant='h6'
        noWrap
        component='div'
        className={styles.appName}
        sx={{ mx: 1, color: 'text.disabled' }}
      >
        Event Manager
      </Typography>
    </>
  );
}

export default HeaderLogo;
